import React, { useState, useEffect } from "react";
import axios from "axios";
import Image from "react-graceful-image";
import UploadPage from "../pages/uploadPage";
import LoadingInd from "./LoadingInd";

export default () => {
  const [user, setUser] = useState("");
  const [imgs, setimgs] = useState([]);
  const [isLoadin, setLoadin] = useState(true);

  useEffect(() => {
    axios({
      url:
        "https://aqueous-plains-06808.herokuapp.com/api/v1/users/me" +
        localStorage.getItem("email"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then((res) => {
      setUser(res.data);
      // console.log(res.data);
    });
    fetchImages();
  }, []);

  const fetchImages = () => {
    axios({
      url:
        "https://aqueous-plains-06808.herokuapp.com/api/v1/users/images/me" +
        localStorage.getItem("email"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then((res) => {
      setimgs(res.data);
      // console.log(res.data);
      setLoadin(false);
    });
  };
  return (
    <div
      className="text-center"
      style={{
        border: "1px solid grey",
        borderRadius: "10px",
      }}
    >
      <h3 className="my-3">
        <b>{user.username}</b>_
      </h3>
      <Image
        style={{
          border: "5px solid brown",
          borderRadius: "10%",
        }}
        src={user.profileImage}
        alt="hehe"
      />
      <UploadPage reFetch={fetchImages} />

      <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}>
        {isLoadin ? (
          <LoadingInd w={30} h={30} />
        ) : (
          imgs.map((o, index) => (
            <div key={index}>
              <Image style={{ width: "100px", height: "100px" }} src={o.img} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};
